import { html } from 'lit-element'

export default async function () {
  await import(/* webpackChunkName: 'activities' */ '../../apps/activities/app')

  return html`
    <pe-activities-app></pe-activities-app>
  `
}
